import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=1a146e4e&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a146e4e')) {
      api.createRecord('1a146e4e', component.options)
    } else {
      api.reload('1a146e4e', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=1a146e4e&", function () {
      api.rerender('1a146e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WN7Nc6LG93E8/JS/comp/starrating.vue"
export default component.exports